







































































import Vue from 'vue';
import Component from 'vue-class-component';

import { ValidationRule } from '@cnamts/vue-dot/src/rules/types';
import { requiredFn } from '@cnamts/vue-dot/src/rules/required';

const Props = Vue.extend({
	props: {
		popinUpdateCheckbox: {
			type: Boolean,
			default: false
		}
	}
});

@Component({
	model: {
		prop: 'popinUpdateCheckbox',
		event: 'change'
	}
})
export default class PopinUpdateCheckbox extends Props {

	validationEnableIdentity = false;
	validationEnableUpdate = false;

	validationEnableIdentityLabel = 'Je demande une pièce d’identité à mon patient (carte nationale d’identité, passeport…).';

	validationEnableUpdateLabel = 'Je m’engage à modifier les informations en fonction des éléments contenus dans ces documents.';

	validationRules: ValidationRule[] = [
		requiredFn({ default: 'Ce champ est obligatoire.' })
	];

	get computedValue(): boolean {
		return this.popinUpdateCheckbox;
	}

	set computedValue(popinUpdateCheckbox: boolean) {
		this.$emit('change', popinUpdateCheckbox);
	}

	goToModify(): void {
		this.computedValue = false;
		this.$router.push({
			name: 'identificationModification',
			query: Object.assign({}, this.$router.currentRoute.query)
		});
	}
}
